//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { debounce } from "quasar";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQCheckbox from "@/components/Generics/AQCheckbox/AQCheckbox.vue";
import AQEmptySearch from "@/components/Generics/AQEmptySearch/AQEmptySearch.vue";
import AQDataColumnSettings from "./AQDataColumnSettings.vue";
import { TABLE_BTM_BTNS, DATA_TABLE_PROPS } from "./AQDataTable.const";

/**
     * EVENTS :
     * "@selectedRows" => emit event with selected row(s)
     * "@pagination" = > emit event with all pagination params on every change
     * "@orderColumnsChanged" = > emit event with new columns order (and new columns from Data Model)
     *
     * SLOTS :
     * topBeforeTable - add extra content before table header
     * bottomAfterTable - add extra content after table body
     * extraTopRow - add extra top rows
     * extraBottomRow - add extra bottom rows
     * headerTemplate - add table custom header template
     * bodyTemplate - add table custom body template
     * gridTemplate - add table custom body template (props "grid = true")
     */

export default {
    name: "AQDataTable",
    components: {
        AQButton,
        AQTooltip,
        AQInput,
        AQCheckbox,
        AQEmptySearch,
        AQDataColumnSettings
    },
    props: {
        ...DATA_TABLE_PROPS
    },
    data() {
        return {
            contentLoaded: false,
            setResizable: false,
            currentPage: 1,
            paginationParams: { rowsPerPage: 10, rowsNumber: 10 },
            selectedRows: [],
            tableColumns: [],
            tableBottomBtns: TABLE_BTM_BTNS,
            hideHeaderOnGrid: false,
            payloadPagination: {
                rowsPerPage: 10,
                currentPage: 1,
                descending: true,
                sortBy: null
            },
            immediatePagination: false,
            triggerPagination: true
        };
    },
    computed: {
        setDataTableStyle() {
            const noDataTableHeight = !this.hideHeaderOnNoData && !this.checkIfTableData ? `height: ${this.noDataDefaultTableHeight}` : "";
            const reduseHeight = this.reduseFromTableHeight ? `height: calc(100% - 42px - ${this.reduseFromTableHeight})` : "";
            return noDataTableHeight || reduseHeight;
        },
        setPaginationLabel() {
            let firstCondition = 0; let secondCondition; let
                finalStatement = "";
            if (this.currentPage > 1) {
                firstCondition = (this.paginationParams.rowsPerPage * (this.currentPage - 1) + 1);
            } else if (this.currentPage === 1) {
                firstCondition = 1;
            } else {
                firstCondition = 0;
            }

            if (firstCondition) {
                const calcLastIndex = this.paginationParams.rowsPerPage * this.currentPage;
                secondCondition = Math.min(calcLastIndex, this.paginationParams.rowsNumber);
                finalStatement = `${firstCondition} - ${secondCondition}${this.$t("dataTable.paginationLabel")}${this.paginationParams.rowsNumber}`;
            }
            return finalStatement;
        },
        getColumnSettProps() {
            return {
                atId: this.atId,
                title: this.settingsTitle,
                columns: this.columns,
                defaultColumns: this.defaultColumns,
                reorder: this.reorderColumns,
                dataModelMode: this.dataModelMode
            };
        },
        showTitleContainer() {
            return (this.title || this.$scopedSlots.titleTemplate || this.showSettings);
        },
        getVisibleColumns() {
            return this.tableColumns.map(elem => ((elem.visible || elem.required) ? elem.name : null));
        },
        getVisibleColumnToSet() {
            return this.tableColumns.filter(elem => elem.visible || elem.required);
        },
        getVisibleColumnLoading() {
            return this.columns.filter(elem => elem.visible || elem.required);
        },
        checkIfTableData() {
            return this.tableData && this.tableData.length;
        },
        disablePreviousPage() {
            return this.currentPage === 1;
        },
        disableLastPage() {
            return this.currentPage >= this.totalPages;
        }
    },
    watch: {
        columns: {
            handler(newValue) {
                this.tableColumns = newValue || [];
            },
            immediate: true
        },
        selectedRows(newValue) {
            this.$emit("selectedRows", newValue);
        },
        selectTableRows: {
            handler(newValue) {
                this.selectedRows = newValue;
            },
            immediate: true
        },
        paginationParams: {
            handler(newValue) {
                if (this.triggerPagination) {
                    if (this.contentLoaded) {
                        this.$emit("pagination", newValue);
                    }
                    this.currentPage = newValue.page;
                }
            },
            deep: true
        },
        currentPage(newValue) {
            if (!this.resetCurrentPage) {
                if (newValue > this.totalPages) {
                    if (this.totalPages) {
                        this.currentPage = this.totalPages;
                    }
                } else if (newValue < 1) {
                    this.currentPage = 1;
                } else if (this.triggerPagination) {
                    this.payloadPagination = { ...this.paginationParams };
                    this.payloadPagination.page = newValue;
                    if (this.immediatePagination) {
                        this.emitPagination();
                    } else {
                        this.debouncedPagination();
                    }
                } else {
                    this.triggerPagination = true;
                }
            }
        },
        resetCurrentPage(newValue) {
            if (newValue) {
                this.currentPage = 1;
            }
        },
        setNewCurentPage(newVal) {
            if (newVal > 0 && newVal <= this.totalPages) {
                this.currentPage = newVal;
            }
        },
        sortPreferences: {
            handler(newValue) {
                const { sortBy, descending } = newValue || {};
                this.paginationParams.sortBy = sortBy;
                this.paginationParams.descending = descending;
            },
            immediate: true,
            deep: true
        },
        grid: {
            handler(newValue) {
                this.hideHeaderOnGrid = !!newValue;
            },
            immediate: true
        },
        pagination: {
            handler(newValue) {
                if (newValue) {
                    const setParams = { ...this.paginationParams, ...newValue };
                    if (newValue.rowsNumber && this.paginationParams.rowsNumber !== newValue.rowsNumber) {
                        this.paginationParams.rowsNumber = newValue.rowsNumber;
                    }
                    this.$refs.AQDataTable.setPagination(setParams);
                    this.triggerPagination = false;
                    this.currentPage = newValue.page;
                    setTimeout(() => {
                        this.triggerPagination = true;
                    }, 0);
                }
            },
            deep: true
        }
    },
    created() {
        this.debouncedPagination = debounce(this.emitPagination, 1200);
    },
    mounted() {
        this.contentLoaded = true;
    },
    methods: {
        emitPagination() {
            this.immediatePagination = false;
            this.$emit("pagination", this.payloadPagination);
        },
        request(props) {
            const { rowsPerPage, sortBy, descending } = props.pagination;
            this.paginationParams.sortBy = sortBy;
            this.paginationParams.descending = descending;
            this.paginationParams.rowsPerPage = rowsPerPage;
        },
        orderColumnsChanged(data) {
            this.$emit("orderColumnsChanged", data);
        },
        selectValue(response, item) {
            const columnIndex = this.settingsData.findIndex(elem => elem.name === item.name);
            if (columnIndex !== -1) {
                this.settingsData[columnIndex].visible = this.selectedColumnSettings.includes(item.name);
            }
        },
        changePagination(actionType) {
            this.immediatePagination = true;
            if (this.contentLoaded) {
                const page = this.currentPage ? parseInt(this.currentPage, 10) : 1;
                switch (actionType) {
                    case "firstPage":
                        this.currentPage = 1;
                        break;
                    case "prev":
                        this.currentPage = page - 1;
                        break;
                    case "next":
                        this.currentPage = page + 1;
                        break;
                    case "lastPage":
                        this.currentPage = this.totalPages;
                        break;
                    default:
                        this.currentPage = 1;
                }
            }
        }
    }
};
